import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function VisitHistoryMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.visit);
  };

  return (
    <MainMenuItem
      itemTitleString="来店履歴"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default VisitHistoryMenuItem;
